<template>
  <section class="vbox">
  <section class="scrollable wrapper">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>分销奖励设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-form-item >
          <el-input  placeholder="店铺名称" v-model="queryParam.name" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="chainStores" style="width: 100%">
        <el-table-column  prop="Name" :show-overflow-tooltip="true" fixed="left" label="店铺名称"> </el-table-column>
        <el-table-column  prop="BusinessName" :show-overflow-tooltip="true" label="所属商家"> </el-table-column>
        <el-table-column  prop="Capital" width="100px"  label="账户余额"> </el-table-column>
        <el-table-column  prop="ShareCommissionRate" :formatter="PercenPtageFormat" label="会员分销抽成"> </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="editChainStore(scope.row)" type="text" size="small">
            设置
          </el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
    <el-dialog :title="chainStore.Name" width="450px" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="chainStore" label-width="100px">       
        <el-form-item label="会员分销抽成">          
          <el-input v-model="chainStore.ShareCommissionRate">            
            <el-button slot="append" >%</el-button>
          </el-input>        
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="SaveShareCommissionRate">确 定</el-button>
      </div>
    </el-dialog> 
  </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        chainStores:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' RegisterTime asc',
        },
        chainStore:{},        
        dialogFormVisible:false
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ChainStore/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.chainStores = resp.data.chainStores
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      editChainStore(row){
        this.chainStore = row
        this.dialogFormVisible = true
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1 
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      },
      SaveShareCommissionRate(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/ChainStore/ChainStoreShareCommissionRateSave',         
          data:that.chainStore
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
            that.dialogFormVisible = false
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      PercenPtageFormat(row, column, cellValue, index){
        let value = row[column.property]
	      return  value +'%'
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>